const WASSERFORM_TOKEN = /^[0-9+xˣ⁺]+$/i;

/**
 * Akzeptiert Einzelwerte ("37", "1+", "2x") und die kombinierte Anzeige
 * "Stauwasserform / Grundwasserform" ("37 / 56"), wie sie im Boden-Reiter
 * über `wasserformString(bp)` dargestellt wird.
 */
export function isValidWasserform(str: string): boolean {
	if (!str) return true;
	return str.split('/').every(part => WASSERFORM_TOKEN.test(part.trim()));
}
